import React, { createContext } from "react"
import { useState } from "react"

const BodyPartContext = createContext()
export default BodyPartContext

export function BodyPartProvider({ ...props }) {
    const [bodyPart, setBodyPart] = useState('')
    return <BodyPartContext.Provider value={[bodyPart, setBodyPart]} {...props} />
}